import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import AiChatbotPage from './pages/AiChatbotPage';
import AutomationPage from './pages/AutomationPage';
import SaasDevelopmentPage from './pages/SaasDevelopmentPage';
import AboutPage from './pages/AboutPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import AiChatbotsSmallBusinessPage from './pages/blog/AiChatbotsSmallBusinessPage';
import AiAutomationEcommercePage from './pages/blog/AiAutomationEcommercePage';

function App() {
  return (
    <Router>
      <div className="relative bg-[#030712] text-white min-h-screen">
        <div className="grain-overlay" />
        <div className="relative z-10">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/ai-chatbot" element={<AiChatbotPage />} />
            <Route path="/automation" element={<AutomationPage />} />
            <Route path="/saas-development" element={<SaasDevelopmentPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/blog/ai-chatbots-small-business" element={<AiChatbotsSmallBusinessPage />} />
            <Route path="/blog/ai-automation-ecommerce" element={<AiAutomationEcommercePage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;